import React from "react";
import { Button } from "react-bootstrap";
import { scroller } from "react-scroll";

const ScrollToCourses = ({
  TargetId = "coursesTop",
  offset = 0,
  className = "btn text-nowrap btn-secondary",
}) => {
  const scrollToTarget = () => {
    scroller.scrollTo(TargetId, {
      duration: 800,
      delay: 0,
      smooth: "easeInOutQuart",
      offset: offset,
    });
  };

  return (
    <Button onClick={scrollToTarget} className={className}>
     Weitere Events
    </Button>
  );
};
export default ScrollToCourses;
